import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../button/Button";
import { faXmark, faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { UserPermission } from "userful-chronos-app-common-js/dist/models/user-permission";
import {
    useMappingDispatch,
    mappingGroupsSliceActions,
    useMappingSelector,
} from "userful-chronos-common-store/dist/mapping";
import { APP_NAMES, StringID } from "userful-chronos-app-common-js/dist/models/common";
import { APP_IDS } from "userful-chronos-app-common-js/dist/models/common";
import { ROUTE_PATH } from "userful-chronos-app-common-js/dist/routing";
import "./DND.scss";

interface IProps {
    mappingGroupID: StringID;
}

// findSceneIDForStandaloneDestUsedByDecisions = (destinations) => {

// }

// findSceneIDForVideoWallDestinationsUsedByDecisions = (dest: CdmVideoWallDest): StringID => {
//      for (const display of dest.displays) {
//           if (!display.endPoint.usage.records[0].)
//      }
// }

export default function DestinationDropInUseConfirmation(props: IProps) {
    const { t } = useTranslation();
    const userPermission = getGlobalStates().userPermission as UserPermission;
    const pendingAddDestinationRequest = useMappingSelector(
        (state) => state.mappingGroupStore.pendingAddDestinationRequest,
    );
    const videoWalls = useMappingSelector((state) => state.videowallsStore.videowallDestinations);
    const displays = useMappingSelector((state) => state.displaysStore.displayDestinations);
    const audios = useMappingSelector((state) => state.audiosStore.audioDestinations);

    const dispatch = useMappingDispatch();
    const [show, setShow] = useState(false);

    const [appIDvalue, setAppIDvalue] = useState("");
    const [appText, setAppText] = useState("");
    const [allowStealing, setAllowStealing] = useState(true);

    useEffect(() => {
        if (
            !show &&
            pendingAddDestinationRequest &&
            pendingAddDestinationRequest.id.value === props.mappingGroupID.value
        ) {
            if (pendingAddDestinationRequest.addDestinations.groups.length === 1) {
            } else if (pendingAddDestinationRequest.addDestinations.videoWalls.length === 1) {
                const destination = videoWalls.find(
                    (v) => v.id.value === pendingAddDestinationRequest.addDestinations.videoWalls[0].value,
                );

                if (destination) {
                    let appCount = 0;
                    let appID = "";
                    let text = "";
                    for (let i = 0; i < destination.displays.length; i++) {
                        const display = destination.displays[i];

                        if (text.length === 0) {
                            const appIDValue = display.endPoint.usage.records[0]?.appInstanceData.id.appID.value;
                            if (appIDValue) {
                                text = APP_NAMES[appIDValue] || text;
                                appID = appIDValue;
                            }
                        } else {
                            const appIDValue = display.endPoint.usage.records[0]?.appInstanceData.id.appID.value;
                            if (appIDValue) {
                                if (appIDValue !== appID) appCount++;
                            }
                        }
                    }

                    if (appCount >= 1) text += " +" + appCount;

                    setAppIDvalue(appID);
                    setAppText(text);
                    setAllowStealing(
                        getGlobalStates().appID.value === APP_IDS.Decisions ||
                            destination.displays.findIndex(
                                (d) =>
                                    d.endPoint.usage.records[0]?.appInstanceData.id.appID.value === APP_IDS.Decisions,
                            ) < 0,
                    );
                }
            } else if (pendingAddDestinationRequest.addDestinations.physicalVideo.length === 1) {
                const destination = displays.find(
                    (d) => d.id.value === pendingAddDestinationRequest.addDestinations.physicalVideo[0].value,
                );
                if (destination) {
                    let appID = "";
                    let text = "";

                    const appIDValue = destination.endPoint.usage.records[0]?.appInstanceData.id.appID.value;
                    if (appIDValue) {
                        text = APP_NAMES[appIDValue] || text;
                        appID = appIDValue;
                    }

                    setAppIDvalue(appID);
                    setAppText(text);
                    setAllowStealing(
                        getGlobalStates().appID.value === APP_IDS.Decisions ||
                            destination.endPoint.usage.records[0]?.appInstanceData.id.appID.value !== APP_IDS.Decisions,
                    );
                }
            } else if (pendingAddDestinationRequest.addDestinations.physicalAudio.length === 1) {
                const destination = audios.find(
                    (d) => d.id.value === pendingAddDestinationRequest.addDestinations.physicalAudio[0].value,
                );
                if (destination) {
                    let appID = "";
                    let text = "";

                    const appIDValue = destination.endPoint.usage.records[0]?.appInstanceData.id.appID.value;
                    if (appIDValue) {
                        text = APP_NAMES[appIDValue] || text;
                        appID = appIDValue;
                    }

                    setAppIDvalue(appID);
                    setAppText(text);
                    setAllowStealing(
                        getGlobalStates().appID.value === APP_IDS.Decisions ||
                            destination.endPoint.usage.records[0]?.appInstanceData.id.appID.value !== APP_IDS.Decisions,
                    );
                }
            }

            setShow(true);
        }
        if (show && !pendingAddDestinationRequest) {
            setShow(false);
        }
    }, [pendingAddDestinationRequest]);

    const handleConfirm = () => {
        dispatch(mappingGroupsSliceActions.confirmAddInUseDestination());

        // console.warn(foundMapper);

        // if (foundMapper) {
        //     dispatch(mappingGroupsSliceActions.removeMappingGroup(foundMapper));
        // }
        setShow(false);
    };

    const goToDecisions = () => {
        window.location.replace(`${ROUTE_PATH.APP.DIAMOND}${window.location.search}`);
    };

    const handleCancel = () => {
        dispatch(mappingGroupsSliceActions.cancelAddInUseDestination());
        setShow(false);
    };

    return (
        <Modal show={show} onHide={handleCancel} aria-labelledby="contained-modal-title-vcenter" centered>
            <div className="modal-header-title" style={{ marginBottom: "0px" }}>
                <Modal.Header>
                    <div>
                        <FontAwesomeIcon icon={faCircleExclamation} style={{ color: " #D13E2C", marginRight: "8px" }} />
                        {t("CommonUI.MappingGroups.ReassignConfirm.Heading")}
                    </div>
                    <div className="modal-close-btn">
                        <FontAwesomeIcon
                            icon={faXmark}
                            onClick={handleCancel}
                            className="custom-close-btn fontAwesomeCustomIcon"
                        />
                    </div>
                </Modal.Header>
            </div>

            <Modal.Body>
                <div className="bodyMainContainer">
                    <div className="bodyMainSubContainer">
                        {allowStealing ? (
                            <>
                                {t("CommonUI.MappingGroups.ReassignConfirm.mainMessageA")}&nbsp;
                                <div className="appHighlight">{appText}</div>
                                {t("CommonUI.MappingGroups.ReassignConfirm.mainMessageB")}
                            </>
                        ) : (
                            <>
                                {t("CommonUI.MappingGroups.ReassignConfirm.mainMessageA")}&nbsp;
                                <div className="appHighlight">{APP_NAMES.ControlRoom}</div>
                                {t("CommonUI.MappingGroups.ReassignConfirm.notAllow")}
                            </>
                        )}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    {t("Shared.cancel")}
                </Button>
                {allowStealing ? (
                    <Button variant="danger" onClick={handleConfirm}>
                        {t("Shared.reassignDestination")}
                    </Button>
                ) : (
                    <Button variant="primary" onClick={goToDecisions}>
                        {t("CommonUI.MappingGroups.ReassignConfirm.goToDecisions")}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}
